export default __webpack_public_path__ + "static/media/document-success-dsk.0a326f43.svg";